import { type Localisation } from "./en";

export const dutch: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "Het scherm is actief maar er is geen token aanwezig",
    "Network error": "Netwerkfout",
    "Checking display status":
      "Bezig met controleren van de status van het scherm",
    "Failed to get display status":
      "Het ophalen van de status van het scherm is mislukt",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Als dit probleem aanhoudt, neem dan contact op met uw Teamworks-beheerder.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Dit komt meestal door een netwerkfout bij het instellen van uw apparaat. Reset uw apparaat met de knop hieronder en probeer het opnieuw.",
    "Setup failed to complete": "De setup is niet voltooid",
    "Please reset your device using the button below and try again.":
      "Reset uw apparaat met de knop hieronder en probeer het opnieuw.",
  },
  ConfigProvider: {
    "Loading configuration": "Configuratie laden",
  },
  AppProvider: {
    Loading: "Laden",
    "No configuration selected": "Geen configuratie geselecteerd",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "We konden geen configuratie vinden voor de opgegeven code. Neem contact op met je Teamworks-beheerder.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Dit apparaat is geregistreerd, maar er is nog geen configuratie ingesteld. Maak je geen zorgen, je kunt dit apparaat eenvoudig bijwerken in de digitale displays beheer-app.",
    "Network error: failed to load playlist":
      "Netwerkfout: het laden van de afspeellijst is mislukt",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...": "Resetten, even geduld aub...",
  },
  UpdatesProvider: {
    "Checking for update": "Controleren op update",
    "Downloading update": "Downloaden van update",
  },
  InteractionScreen: {
    "Loading...": "Laden...",
    "Press any key to begin": "Druk op een toets om te beginnen",
    "No configurations assigned": "Geen configuraties toegewezen",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Je kunt een configuratie of een afspeellijst toewijzen om op dit apparaat te draaien via de digitale displays beheer-app.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app": "Scan de QR-code met uw camera-app",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Evenementenpagina {{count}} van {{total}}",
    Today: "Vandaag",
    "All day": "De hele dag",
    Tomorrow: "Morgen",
  },
  ErrorScreen: {
    "Something went wrong": "Er is iets misgegaan",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Sorry voor het ongemak, onze ingenieurs zijn op de hoogte gebracht en zullen werken aan een oplossing",
    "If this issue persists, please contact your account manager":
      "Als dit probleem aanhoudt, neem dan contact op met uw accountmanager",
    "Reset device": "Apparaat resetten",
    "Your IP address may need to be permitted: {{ip}}":
      "Uw IP-adres moet mogelijk worden toegestaan: {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "De app zal automatisch resetten in {{seconds}} seconden",
  },
  NextMatch: {
    days: "dagen",
    hours: "uren",
    minutes: "minuten",
    seconds: "seconden",
  },
  MediaContentCarosel: {
    "Media not found": "Media niet gevonden",
  },
  PlaylistProvider: {
    "Loading...": "Laden...",
    "Loading playlist": "Afspeellijst laden",
  },
  ScreenFooter: {
    Hardcoded: "Hardcoded",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuratie niet gevonden",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Geen workout geselecteerd",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Selecteer een workout in het tabblad Digital Display in S&C om het hier weer te geven",
  },
  WeatherWidget: {
    "Weather unavailable": "Weer niet beschikbaar",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Het ophalen van het menu is mislukt",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "Het ophalen van het eetstation is mislukt",
    "Add ons will affect nutrition information":
      "Toevoegingen beïnvloeden de voedingsinformatie",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Geen weergegevens om te tonen, neem contact op met uw Teamworks-beheerder.",
    Clear: "Helder",
    Clouds: "Bewolkt",
    Rain: "Regen",
    Drizzle: "Motregen",
    Thunderstorm: "Onweer",
    Snow: "Sneeuw",
    Mist: "Mist",
    Smoke: "Rook",
    Haze: "Nevel",
    Dust: "Stof",
    Fog: "Dichte mist",
    Sand: "Zand",
    Ash: "Vulkanische as",
    Squall: "Windvlaag",
    Tornado: "Tornado",
  },
};
